//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../axios-client';
import { useQuery, useMutation } from '@tanstack/react-query';
import type { UseQueryResult, QueryFunctionContext, UseQueryOptions, QueryClient, QueryKey, MutationKey, UseMutationOptions, UseMutationResult, QueryMeta, MutationMeta } from '@tanstack/react-query';
import { trimArrayEnd, isParameterObject, getBaseUrl, addMetaToOptions } from './helpers';
import type { QueryMetaContextValue } from 'react-query-swagger';
import { QueryMetaContext } from 'react-query-swagger';
import { useContext } from 'react';
import * as Client from './PortfoliosClient'
export { Client };
import type { AxiosRequestConfig } from 'axios';


export type PortfoliosGetPortfoliosQueryParameters = {
  id: string ;
}

export type PortfoliosUpdatePortfoliosQueryParameters = {
  id: string ;
}

export type PortfoliosDeletePortfoliosQueryParameters = {
  id: string ;
}

export type PortfoliosGetTimeSeriesPortfoliosQueryParameters = {
  id: string ;
  start?: string | undefined ;
  end?: string | undefined ;
  includeTransactions?: boolean | undefined ;
}

export type PortfoliosGetSyncSettingsPortfoliosQueryParameters = {
  id: string ;
  providerName?: string | undefined ;
  accountIdentifier?: string | undefined ;
}

export type PortfoliosSortPortfoliosQueryParameters = {
  portfolioId: string ;
}

export type PortfoliosDeleteSyncedPortfolioPortfoliosQueryParameters = {
  id: string ;
  syncedPortfolioId: string ;
}

export type PortfoliosCreateSectionPortfoliosQueryParameters = {
  id: string ;
}

export type PortfoliosUpdateSectionPortfoliosQueryParameters = {
  id: string ;
  sectionId: string ;
}

export type PortfoliosDeleteSectionPortfoliosQueryParameters = {
  id: string ;
  sectionId: string ;
}

export type PortfoliosSortSectionPortfoliosQueryParameters = {
  id: string ;
  sectionId: string ;
}

export type PortfoliosMoveAssetPortfoliosQueryParameters = {
  id: string ;
}

export type PortfoliosGetSectionLookupPortfoliosQueryParameters = {
  portfolioIds?: string[] | undefined ;
}

export type PortfoliosAddAssetPortfoliosQueryParameters = {
  id: string ;
  sectionId: string ;
}

export type PortfoliosUpdateAssetPortfoliosQueryParameters = {
  id: string ;
  sectionId: string ;
  assetId: string ;
}

export type PortfoliosDeleteAssetPortfoliosQueryParameters = {
  id: string ;
  sectionId: string ;
  assetId: string ;
}

export function portfoliosGetListUrl(): string {
  let url_ = getBaseUrl() + "/api/portfolios";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let portfoliosGetListDefaultOptions: Omit<UseQueryOptions<Types.ListResultDtoOfLookupDtoOfGuid, unknown, Types.ListResultDtoOfLookupDtoOfGuid>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.ListResultDtoOfLookupDtoOfGuid, unknown, Types.ListResultDtoOfLookupDtoOfGuid>, 'queryFn'>> = {
};
export function getPortfoliosGetListDefaultOptions() {
  return portfoliosGetListDefaultOptions;
};
export function setPortfoliosGetListDefaultOptions(options: typeof portfoliosGetListDefaultOptions) {
  portfoliosGetListDefaultOptions = options;
}

export function portfoliosGetListQueryKey(): QueryKey;
export function portfoliosGetListQueryKey(...params: any[]): QueryKey {
  return trimArrayEnd([
      'PortfoliosClient',
      'portfoliosGetList',
    ]);
}
export function __portfoliosGetList(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.portfoliosGetList(
axiosConfig    );
}

/**
 * @return OK
 */
export function usePortfoliosGetListQuery<TSelectData = Types.ListResultDtoOfLookupDtoOfGuid, TError = unknown>(options?: Omit<UseQueryOptions<Types.ListResultDtoOfLookupDtoOfGuid, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function usePortfoliosGetListQuery<TSelectData = Types.ListResultDtoOfLookupDtoOfGuid, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.ListResultDtoOfLookupDtoOfGuid, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  

  options = params[0] as any;
  axiosConfig = params[1] as any;

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.ListResultDtoOfLookupDtoOfGuid, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __portfoliosGetList(context, axiosConfig) : __portfoliosGetList,
    queryKey: portfoliosGetListQueryKey(),
    ...portfoliosGetListDefaultOptions as unknown as Omit<UseQueryOptions<Types.ListResultDtoOfLookupDtoOfGuid, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * @return OK
 */
export function setPortfoliosGetListData(queryClient: QueryClient, updater: (data: Types.ListResultDtoOfLookupDtoOfGuid | undefined) => Types.ListResultDtoOfLookupDtoOfGuid, ) {
  queryClient.setQueryData(portfoliosGetListQueryKey(),
    updater
  );
}

/**
 * @return OK
 */
export function setPortfoliosGetListDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.ListResultDtoOfLookupDtoOfGuid | undefined) => Types.ListResultDtoOfLookupDtoOfGuid) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function portfoliosCreateUrl(): string {
  let url_ = getBaseUrl() + "/api/portfolios";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function portfoliosCreateMutationKey(): MutationKey {
  return trimArrayEnd([
      'PortfoliosClient',
      'portfoliosCreate',
    ]);
}

/**
 * @param body (optional) 
 * @return OK
 */
export function usePortfoliosCreateMutation<TContext>(options?: Omit<UseMutationOptions<Types.PortfolioDto, unknown, Types.PortfolioCreateDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.PortfolioDto, unknown, Types.PortfolioCreateDto, TContext> {
  const key = portfoliosCreateMutationKey();
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (body: Types.PortfolioCreateDto) => Client.portfoliosCreate(body),
    mutationKey: key,
  });
}
  
export function portfoliosGetUrl(id: string): string {
  let url_ = getBaseUrl() + "/api/portfolios/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let portfoliosGetDefaultOptions: Omit<UseQueryOptions<Types.PortfolioDto, unknown, Types.PortfolioDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.PortfolioDto, unknown, Types.PortfolioDto>, 'queryFn'>> = {
};
export function getPortfoliosGetDefaultOptions() {
  return portfoliosGetDefaultOptions;
};
export function setPortfoliosGetDefaultOptions(options: typeof portfoliosGetDefaultOptions) {
  portfoliosGetDefaultOptions = options;
}

export function portfoliosGetQueryKey(id: string): QueryKey;
export function portfoliosGetQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { id,  } = params[0] as PortfoliosGetPortfoliosQueryParameters;

    return trimArrayEnd([
        'PortfoliosClient',
        'portfoliosGet',
        id as any,
      ]);
  } else {
    return trimArrayEnd([
        'PortfoliosClient',
        'portfoliosGet',
        ...params
      ]);
  }
}
export function __portfoliosGet(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.portfoliosGet(
      context.queryKey[2] as string,axiosConfig    );
}

export function usePortfoliosGetQuery<TSelectData = Types.PortfolioDto, TError = unknown>(dto: PortfoliosGetPortfoliosQueryParameters, options?: Omit<UseQueryOptions<Types.PortfolioDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * @return OK
 */
export function usePortfoliosGetQuery<TSelectData = Types.PortfolioDto, TError = unknown>(id: string, options?: Omit<UseQueryOptions<Types.PortfolioDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function usePortfoliosGetQuery<TSelectData = Types.PortfolioDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.PortfolioDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let id: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ id,  } = params[0] as PortfoliosGetPortfoliosQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [id, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.PortfolioDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __portfoliosGet(context, axiosConfig) : __portfoliosGet,
    queryKey: portfoliosGetQueryKey(id),
    ...portfoliosGetDefaultOptions as unknown as Omit<UseQueryOptions<Types.PortfolioDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * @return OK
 */
export function setPortfoliosGetData(queryClient: QueryClient, updater: (data: Types.PortfolioDto | undefined) => Types.PortfolioDto, id: string) {
  queryClient.setQueryData(portfoliosGetQueryKey(id),
    updater
  );
}

/**
 * @return OK
 */
export function setPortfoliosGetDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.PortfolioDto | undefined) => Types.PortfolioDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function portfoliosUpdateUrl(id: string): string {
  let url_ = getBaseUrl() + "/api/portfolios/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function portfoliosUpdateMutationKey(id: string): MutationKey {
  return trimArrayEnd([
      'PortfoliosClient',
      'portfoliosUpdate',
      id as any,
    ]);
}

/**
 * @param body (optional) 
 * @return OK
 */
export function usePortfoliosUpdateMutation<TContext>(id: string, options?: Omit<UseMutationOptions<Types.PortfolioDto, unknown, Types.PortfolioUpdateDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.PortfolioDto, unknown, Types.PortfolioUpdateDto, TContext> {
  const key = portfoliosUpdateMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (body: Types.PortfolioUpdateDto) => Client.portfoliosUpdate(id, body),
    mutationKey: key,
  });
}
  
type PortfoliosUpdate__MutationParameters = PortfoliosUpdatePortfoliosQueryParameters & {
  body: Types.PortfolioUpdateDto;
}

/**
 * @param body (optional) 
 * @return OK
 */
export function usePortfoliosUpdateMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<Types.PortfolioDto, unknown, PortfoliosUpdate__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: PortfoliosUpdatePortfoliosQueryParameters}): UseMutationResult<Types.PortfolioDto, unknown, PortfoliosUpdate__MutationParameters, TContext> {
  const key = portfoliosUpdateMutationKey(options?.parameters?.id!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: PortfoliosUpdate__MutationParameters) => Client.portfoliosUpdate(data.id ?? options?.parameters?.id!, data.body),
  mutationKey: key,
});
}
  
export function portfoliosDeleteUrl(id: string): string {
  let url_ = getBaseUrl() + "/api/portfolios/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function portfoliosDeleteMutationKey(id: string): MutationKey {
  return trimArrayEnd([
      'PortfoliosClient',
      'portfoliosDelete',
      id as any,
    ]);
}

/**
 * @return OK
 */
export function usePortfoliosDeleteMutation<TContext>(id: string, options?: Omit<UseMutationOptions<void, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, void, TContext> {
  const key = portfoliosDeleteMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: () => Client.portfoliosDelete(id),
    mutationKey: key,
  });
}
  
type PortfoliosDelete__MutationParameters = PortfoliosDeletePortfoliosQueryParameters

/**
 * @return OK
 */
export function usePortfoliosDeleteMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<void, unknown, PortfoliosDelete__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: PortfoliosDeletePortfoliosQueryParameters}): UseMutationResult<void, unknown, PortfoliosDelete__MutationParameters, TContext> {
  const key = portfoliosDeleteMutationKey(options?.parameters?.id!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: PortfoliosDelete__MutationParameters) => Client.portfoliosDelete(data.id ?? options?.parameters?.id!),
  mutationKey: key,
});
}
  
export function portfoliosGetTimeSeriesUrl(id: string, start?: string | undefined, end?: string | undefined, includeTransactions?: boolean | undefined): string {
  let url_ = getBaseUrl() + "/api/portfolios/{id}/timeseries?";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
if (start === null)
    throw new Error("The parameter 'start' cannot be null.");
else if (start !== undefined)
    url_ += "Start=" + encodeURIComponent("" + start) + "&";
if (end === null)
    throw new Error("The parameter 'end' cannot be null.");
else if (end !== undefined)
    url_ += "End=" + encodeURIComponent("" + end) + "&";
if (includeTransactions === null)
    throw new Error("The parameter 'includeTransactions' cannot be null.");
else if (includeTransactions !== undefined)
    url_ += "IncludeTransactions=" + encodeURIComponent("" + includeTransactions) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let portfoliosGetTimeSeriesDefaultOptions: Omit<UseQueryOptions<Types.ListResultDtoOfBucketDto, unknown, Types.ListResultDtoOfBucketDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.ListResultDtoOfBucketDto, unknown, Types.ListResultDtoOfBucketDto>, 'queryFn'>> = {
};
export function getPortfoliosGetTimeSeriesDefaultOptions() {
  return portfoliosGetTimeSeriesDefaultOptions;
};
export function setPortfoliosGetTimeSeriesDefaultOptions(options: typeof portfoliosGetTimeSeriesDefaultOptions) {
  portfoliosGetTimeSeriesDefaultOptions = options;
}

export function portfoliosGetTimeSeriesQueryKey(dto: PortfoliosGetTimeSeriesPortfoliosQueryParameters): QueryKey;
export function portfoliosGetTimeSeriesQueryKey(id: string, start?: string | undefined, end?: string | undefined, includeTransactions?: boolean | undefined): QueryKey;
export function portfoliosGetTimeSeriesQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { id, start, end, includeTransactions,  } = params[0] as PortfoliosGetTimeSeriesPortfoliosQueryParameters;

    return trimArrayEnd([
        'PortfoliosClient',
        'portfoliosGetTimeSeries',
        id as any,
        start as any,
        end as any,
        includeTransactions as any,
      ]);
  } else {
    return trimArrayEnd([
        'PortfoliosClient',
        'portfoliosGetTimeSeries',
        ...params
      ]);
  }
}
export function __portfoliosGetTimeSeries(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.portfoliosGetTimeSeries(
      context.queryKey[2] as string,       context.queryKey[3] as string | undefined,       context.queryKey[4] as string | undefined,       context.queryKey[5] as boolean | undefined,axiosConfig    );
}

export function usePortfoliosGetTimeSeriesQuery<TSelectData = Types.ListResultDtoOfBucketDto, TError = unknown>(dto: PortfoliosGetTimeSeriesPortfoliosQueryParameters, options?: Omit<UseQueryOptions<Types.ListResultDtoOfBucketDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * @param start (optional) 
 * @param end (optional) 
 * @param includeTransactions (optional) 
 * @return OK
 */
export function usePortfoliosGetTimeSeriesQuery<TSelectData = Types.ListResultDtoOfBucketDto, TError = unknown>(id: string, start?: string | undefined, end?: string | undefined, includeTransactions?: boolean | undefined, options?: Omit<UseQueryOptions<Types.ListResultDtoOfBucketDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function usePortfoliosGetTimeSeriesQuery<TSelectData = Types.ListResultDtoOfBucketDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.ListResultDtoOfBucketDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let id: any = undefined;
  let start: any = undefined;
  let end: any = undefined;
  let includeTransactions: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ id, start, end, includeTransactions,  } = params[0] as PortfoliosGetTimeSeriesPortfoliosQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [id, start, end, includeTransactions, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.ListResultDtoOfBucketDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __portfoliosGetTimeSeries(context, axiosConfig) : __portfoliosGetTimeSeries,
    queryKey: portfoliosGetTimeSeriesQueryKey(id, start, end, includeTransactions),
    ...portfoliosGetTimeSeriesDefaultOptions as unknown as Omit<UseQueryOptions<Types.ListResultDtoOfBucketDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * @param start (optional) 
 * @param end (optional) 
 * @param includeTransactions (optional) 
 * @return OK
 */
export function setPortfoliosGetTimeSeriesData(queryClient: QueryClient, updater: (data: Types.ListResultDtoOfBucketDto | undefined) => Types.ListResultDtoOfBucketDto, id: string, start?: string | undefined, end?: string | undefined, includeTransactions?: boolean | undefined) {
  queryClient.setQueryData(portfoliosGetTimeSeriesQueryKey(id, start, end, includeTransactions),
    updater
  );
}

/**
 * @param start (optional) 
 * @param end (optional) 
 * @param includeTransactions (optional) 
 * @return OK
 */
export function setPortfoliosGetTimeSeriesDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.ListResultDtoOfBucketDto | undefined) => Types.ListResultDtoOfBucketDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function portfoliosGetSyncSettingsUrl(id: string, providerName?: string | undefined, accountIdentifier?: string | undefined): string {
  let url_ = getBaseUrl() + "/api/portfolios/{id}/sync-settings?";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
if (providerName === null)
    throw new Error("The parameter 'providerName' cannot be null.");
else if (providerName !== undefined)
    url_ += "providerName=" + encodeURIComponent("" + providerName) + "&";
if (accountIdentifier === null)
    throw new Error("The parameter 'accountIdentifier' cannot be null.");
else if (accountIdentifier !== undefined)
    url_ += "accountIdentifier=" + encodeURIComponent("" + accountIdentifier) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let portfoliosGetSyncSettingsDefaultOptions: Omit<UseQueryOptions<Types.ListResultDtoOfSyncedAssetDto, unknown, Types.ListResultDtoOfSyncedAssetDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.ListResultDtoOfSyncedAssetDto, unknown, Types.ListResultDtoOfSyncedAssetDto>, 'queryFn'>> = {
};
export function getPortfoliosGetSyncSettingsDefaultOptions() {
  return portfoliosGetSyncSettingsDefaultOptions;
};
export function setPortfoliosGetSyncSettingsDefaultOptions(options: typeof portfoliosGetSyncSettingsDefaultOptions) {
  portfoliosGetSyncSettingsDefaultOptions = options;
}

export function portfoliosGetSyncSettingsQueryKey(dto: PortfoliosGetSyncSettingsPortfoliosQueryParameters): QueryKey;
export function portfoliosGetSyncSettingsQueryKey(id: string, providerName?: string | undefined, accountIdentifier?: string | undefined): QueryKey;
export function portfoliosGetSyncSettingsQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { id, providerName, accountIdentifier,  } = params[0] as PortfoliosGetSyncSettingsPortfoliosQueryParameters;

    return trimArrayEnd([
        'PortfoliosClient',
        'portfoliosGetSyncSettings',
        id as any,
        providerName as any,
        accountIdentifier as any,
      ]);
  } else {
    return trimArrayEnd([
        'PortfoliosClient',
        'portfoliosGetSyncSettings',
        ...params
      ]);
  }
}
export function __portfoliosGetSyncSettings(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.portfoliosGetSyncSettings(
      context.queryKey[2] as string,       context.queryKey[3] as string | undefined,       context.queryKey[4] as string | undefined,axiosConfig    );
}

export function usePortfoliosGetSyncSettingsQuery<TSelectData = Types.ListResultDtoOfSyncedAssetDto, TError = unknown>(dto: PortfoliosGetSyncSettingsPortfoliosQueryParameters, options?: Omit<UseQueryOptions<Types.ListResultDtoOfSyncedAssetDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * @param providerName (optional) 
 * @param accountIdentifier (optional) 
 * @return OK
 */
export function usePortfoliosGetSyncSettingsQuery<TSelectData = Types.ListResultDtoOfSyncedAssetDto, TError = unknown>(id: string, providerName?: string | undefined, accountIdentifier?: string | undefined, options?: Omit<UseQueryOptions<Types.ListResultDtoOfSyncedAssetDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function usePortfoliosGetSyncSettingsQuery<TSelectData = Types.ListResultDtoOfSyncedAssetDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.ListResultDtoOfSyncedAssetDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let id: any = undefined;
  let providerName: any = undefined;
  let accountIdentifier: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ id, providerName, accountIdentifier,  } = params[0] as PortfoliosGetSyncSettingsPortfoliosQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [id, providerName, accountIdentifier, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.ListResultDtoOfSyncedAssetDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __portfoliosGetSyncSettings(context, axiosConfig) : __portfoliosGetSyncSettings,
    queryKey: portfoliosGetSyncSettingsQueryKey(id, providerName, accountIdentifier),
    ...portfoliosGetSyncSettingsDefaultOptions as unknown as Omit<UseQueryOptions<Types.ListResultDtoOfSyncedAssetDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * @param providerName (optional) 
 * @param accountIdentifier (optional) 
 * @return OK
 */
export function setPortfoliosGetSyncSettingsData(queryClient: QueryClient, updater: (data: Types.ListResultDtoOfSyncedAssetDto | undefined) => Types.ListResultDtoOfSyncedAssetDto, id: string, providerName?: string | undefined, accountIdentifier?: string | undefined) {
  queryClient.setQueryData(portfoliosGetSyncSettingsQueryKey(id, providerName, accountIdentifier),
    updater
  );
}

/**
 * @param providerName (optional) 
 * @param accountIdentifier (optional) 
 * @return OK
 */
export function setPortfoliosGetSyncSettingsDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.ListResultDtoOfSyncedAssetDto | undefined) => Types.ListResultDtoOfSyncedAssetDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function portfoliosSortUrl(portfolioId: string): string {
  let url_ = getBaseUrl() + "/api/portfolios/{portfolioId}/sort";
if (portfolioId === undefined || portfolioId === null)
  throw new Error("The parameter 'portfolioId' must be defined.");
url_ = url_.replace("{portfolioId}", encodeURIComponent("" + portfolioId));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function portfoliosSortMutationKey(portfolioId: string): MutationKey {
  return trimArrayEnd([
      'PortfoliosClient',
      'portfoliosSort',
      portfolioId as any,
    ]);
}

/**
 * @param body (optional) 
 * @return OK
 */
export function usePortfoliosSortMutation<TContext>(portfolioId: string, options?: Omit<UseMutationOptions<Types.PortfolioDto, unknown, Types.PortfolioSortingDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.PortfolioDto, unknown, Types.PortfolioSortingDto, TContext> {
  const key = portfoliosSortMutationKey(portfolioId);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (body: Types.PortfolioSortingDto) => Client.portfoliosSort(portfolioId, body),
    mutationKey: key,
  });
}
  
type PortfoliosSort__MutationParameters = PortfoliosSortPortfoliosQueryParameters & {
  body: Types.PortfolioSortingDto;
}

/**
 * @param body (optional) 
 * @return OK
 */
export function usePortfoliosSortMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<Types.PortfolioDto, unknown, PortfoliosSort__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: PortfoliosSortPortfoliosQueryParameters}): UseMutationResult<Types.PortfolioDto, unknown, PortfoliosSort__MutationParameters, TContext> {
  const key = portfoliosSortMutationKey(options?.parameters?.portfolioId!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: PortfoliosSort__MutationParameters) => Client.portfoliosSort(data.portfolioId ?? options?.parameters?.portfolioId!, data.body),
  mutationKey: key,
});
}
  
export function portfoliosDeleteSyncedPortfolioUrl(id: string, syncedPortfolioId: string): string {
  let url_ = getBaseUrl() + "/api/portfolios/{id}/synced-portfolio/{syncedPortfolioId}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
if (syncedPortfolioId === undefined || syncedPortfolioId === null)
  throw new Error("The parameter 'syncedPortfolioId' must be defined.");
url_ = url_.replace("{syncedPortfolioId}", encodeURIComponent("" + syncedPortfolioId));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function portfoliosDeleteSyncedPortfolioMutationKey(id: string, syncedPortfolioId: string): MutationKey {
  return trimArrayEnd([
      'PortfoliosClient',
      'portfoliosDeleteSyncedPortfolio',
      id as any,
      syncedPortfolioId as any,
    ]);
}

/**
 * @return OK
 */
export function usePortfoliosDeleteSyncedPortfolioMutation<TContext>(id: string, syncedPortfolioId: string, options?: Omit<UseMutationOptions<Types.PortfolioDto, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.PortfolioDto, unknown, void, TContext> {
  const key = portfoliosDeleteSyncedPortfolioMutationKey(id, syncedPortfolioId);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: () => Client.portfoliosDeleteSyncedPortfolio(id, syncedPortfolioId),
    mutationKey: key,
  });
}
  
type PortfoliosDeleteSyncedPortfolio__MutationParameters = PortfoliosDeleteSyncedPortfolioPortfoliosQueryParameters

/**
 * @return OK
 */
export function usePortfoliosDeleteSyncedPortfolioMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<Types.PortfolioDto, unknown, PortfoliosDeleteSyncedPortfolio__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: PortfoliosDeleteSyncedPortfolioPortfoliosQueryParameters}): UseMutationResult<Types.PortfolioDto, unknown, PortfoliosDeleteSyncedPortfolio__MutationParameters, TContext> {
  const key = portfoliosDeleteSyncedPortfolioMutationKey(options?.parameters?.id!, options?.parameters?.syncedPortfolioId!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: PortfoliosDeleteSyncedPortfolio__MutationParameters) => Client.portfoliosDeleteSyncedPortfolio(data.id ?? options?.parameters?.id!, data.syncedPortfolioId ?? options?.parameters?.syncedPortfolioId!),
  mutationKey: key,
});
}
  
export function portfoliosCreateSectionUrl(id: string): string {
  let url_ = getBaseUrl() + "/api/portfolios/{id}/sections";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function portfoliosCreateSectionMutationKey(id: string): MutationKey {
  return trimArrayEnd([
      'PortfoliosClient',
      'portfoliosCreateSection',
      id as any,
    ]);
}

/**
 * @param body (optional) 
 * @return OK
 */
export function usePortfoliosCreateSectionMutation<TContext>(id: string, options?: Omit<UseMutationOptions<Types.SectionDto, unknown, Types.SectionCreateDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.SectionDto, unknown, Types.SectionCreateDto, TContext> {
  const key = portfoliosCreateSectionMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (body: Types.SectionCreateDto) => Client.portfoliosCreateSection(id, body),
    mutationKey: key,
  });
}
  
type PortfoliosCreateSection__MutationParameters = PortfoliosCreateSectionPortfoliosQueryParameters & {
  body: Types.SectionCreateDto;
}

/**
 * @param body (optional) 
 * @return OK
 */
export function usePortfoliosCreateSectionMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<Types.SectionDto, unknown, PortfoliosCreateSection__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: PortfoliosCreateSectionPortfoliosQueryParameters}): UseMutationResult<Types.SectionDto, unknown, PortfoliosCreateSection__MutationParameters, TContext> {
  const key = portfoliosCreateSectionMutationKey(options?.parameters?.id!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: PortfoliosCreateSection__MutationParameters) => Client.portfoliosCreateSection(data.id ?? options?.parameters?.id!, data.body),
  mutationKey: key,
});
}
  
export function portfoliosUpdateSectionUrl(id: string, sectionId: string): string {
  let url_ = getBaseUrl() + "/api/portfolios/{id}/sections/{sectionId}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
if (sectionId === undefined || sectionId === null)
  throw new Error("The parameter 'sectionId' must be defined.");
url_ = url_.replace("{sectionId}", encodeURIComponent("" + sectionId));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function portfoliosUpdateSectionMutationKey(id: string, sectionId: string): MutationKey {
  return trimArrayEnd([
      'PortfoliosClient',
      'portfoliosUpdateSection',
      id as any,
      sectionId as any,
    ]);
}

/**
 * @param body (optional) 
 * @return OK
 */
export function usePortfoliosUpdateSectionMutation<TContext>(id: string, sectionId: string, options?: Omit<UseMutationOptions<Types.SectionDto, unknown, Types.SectionUpdateDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.SectionDto, unknown, Types.SectionUpdateDto, TContext> {
  const key = portfoliosUpdateSectionMutationKey(id, sectionId);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (body: Types.SectionUpdateDto) => Client.portfoliosUpdateSection(id, sectionId, body),
    mutationKey: key,
  });
}
  
type PortfoliosUpdateSection__MutationParameters = PortfoliosUpdateSectionPortfoliosQueryParameters & {
  body: Types.SectionUpdateDto;
}

/**
 * @param body (optional) 
 * @return OK
 */
export function usePortfoliosUpdateSectionMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<Types.SectionDto, unknown, PortfoliosUpdateSection__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: PortfoliosUpdateSectionPortfoliosQueryParameters}): UseMutationResult<Types.SectionDto, unknown, PortfoliosUpdateSection__MutationParameters, TContext> {
  const key = portfoliosUpdateSectionMutationKey(options?.parameters?.id!, options?.parameters?.sectionId!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: PortfoliosUpdateSection__MutationParameters) => Client.portfoliosUpdateSection(data.id ?? options?.parameters?.id!, data.sectionId ?? options?.parameters?.sectionId!, data.body),
  mutationKey: key,
});
}
  
export function portfoliosDeleteSectionUrl(id: string, sectionId: string): string {
  let url_ = getBaseUrl() + "/api/portfolios/{id}/sections/{sectionId}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
if (sectionId === undefined || sectionId === null)
  throw new Error("The parameter 'sectionId' must be defined.");
url_ = url_.replace("{sectionId}", encodeURIComponent("" + sectionId));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function portfoliosDeleteSectionMutationKey(id: string, sectionId: string): MutationKey {
  return trimArrayEnd([
      'PortfoliosClient',
      'portfoliosDeleteSection',
      id as any,
      sectionId as any,
    ]);
}

/**
 * @return OK
 */
export function usePortfoliosDeleteSectionMutation<TContext>(id: string, sectionId: string, options?: Omit<UseMutationOptions<Types.PortfolioDto, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.PortfolioDto, unknown, void, TContext> {
  const key = portfoliosDeleteSectionMutationKey(id, sectionId);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: () => Client.portfoliosDeleteSection(id, sectionId),
    mutationKey: key,
  });
}
  
type PortfoliosDeleteSection__MutationParameters = PortfoliosDeleteSectionPortfoliosQueryParameters

/**
 * @return OK
 */
export function usePortfoliosDeleteSectionMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<Types.PortfolioDto, unknown, PortfoliosDeleteSection__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: PortfoliosDeleteSectionPortfoliosQueryParameters}): UseMutationResult<Types.PortfolioDto, unknown, PortfoliosDeleteSection__MutationParameters, TContext> {
  const key = portfoliosDeleteSectionMutationKey(options?.parameters?.id!, options?.parameters?.sectionId!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: PortfoliosDeleteSection__MutationParameters) => Client.portfoliosDeleteSection(data.id ?? options?.parameters?.id!, data.sectionId ?? options?.parameters?.sectionId!),
  mutationKey: key,
});
}
  
export function portfoliosSortSectionUrl(id: string, sectionId: string): string {
  let url_ = getBaseUrl() + "/api/portfolios/{id}/sections/{sectionId}/sort";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
if (sectionId === undefined || sectionId === null)
  throw new Error("The parameter 'sectionId' must be defined.");
url_ = url_.replace("{sectionId}", encodeURIComponent("" + sectionId));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function portfoliosSortSectionMutationKey(id: string, sectionId: string): MutationKey {
  return trimArrayEnd([
      'PortfoliosClient',
      'portfoliosSortSection',
      id as any,
      sectionId as any,
    ]);
}

/**
 * @param body (optional) 
 * @return OK
 */
export function usePortfoliosSortSectionMutation<TContext>(id: string, sectionId: string, options?: Omit<UseMutationOptions<Types.PortfolioDto, unknown, Types.SectionSortingDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.PortfolioDto, unknown, Types.SectionSortingDto, TContext> {
  const key = portfoliosSortSectionMutationKey(id, sectionId);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (body: Types.SectionSortingDto) => Client.portfoliosSortSection(id, sectionId, body),
    mutationKey: key,
  });
}
  
type PortfoliosSortSection__MutationParameters = PortfoliosSortSectionPortfoliosQueryParameters & {
  body: Types.SectionSortingDto;
}

/**
 * @param body (optional) 
 * @return OK
 */
export function usePortfoliosSortSectionMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<Types.PortfolioDto, unknown, PortfoliosSortSection__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: PortfoliosSortSectionPortfoliosQueryParameters}): UseMutationResult<Types.PortfolioDto, unknown, PortfoliosSortSection__MutationParameters, TContext> {
  const key = portfoliosSortSectionMutationKey(options?.parameters?.id!, options?.parameters?.sectionId!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: PortfoliosSortSection__MutationParameters) => Client.portfoliosSortSection(data.id ?? options?.parameters?.id!, data.sectionId ?? options?.parameters?.sectionId!, data.body),
  mutationKey: key,
});
}
  
export function portfoliosMoveAssetUrl(id: string): string {
  let url_ = getBaseUrl() + "/api/portfolios/{id}/move-asset";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function portfoliosMoveAssetMutationKey(id: string): MutationKey {
  return trimArrayEnd([
      'PortfoliosClient',
      'portfoliosMoveAsset',
      id as any,
    ]);
}

/**
 * @param body (optional) 
 * @return OK
 */
export function usePortfoliosMoveAssetMutation<TContext>(id: string, options?: Omit<UseMutationOptions<Types.PortfolioDto, unknown, Types.MoveAssetDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.PortfolioDto, unknown, Types.MoveAssetDto, TContext> {
  const key = portfoliosMoveAssetMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (body: Types.MoveAssetDto) => Client.portfoliosMoveAsset(id, body),
    mutationKey: key,
  });
}
  
type PortfoliosMoveAsset__MutationParameters = PortfoliosMoveAssetPortfoliosQueryParameters & {
  body: Types.MoveAssetDto;
}

/**
 * @param body (optional) 
 * @return OK
 */
export function usePortfoliosMoveAssetMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<Types.PortfolioDto, unknown, PortfoliosMoveAsset__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: PortfoliosMoveAssetPortfoliosQueryParameters}): UseMutationResult<Types.PortfolioDto, unknown, PortfoliosMoveAsset__MutationParameters, TContext> {
  const key = portfoliosMoveAssetMutationKey(options?.parameters?.id!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: PortfoliosMoveAsset__MutationParameters) => Client.portfoliosMoveAsset(data.id ?? options?.parameters?.id!, data.body),
  mutationKey: key,
});
}
  
export function portfoliosGetSectionLookupUrl(portfolioIds?: string[] | undefined): string {
  let url_ = getBaseUrl() + "/api/portfolios/sections/lookup?";
if (portfolioIds === null)
    throw new Error("The parameter 'portfolioIds' cannot be null.");
else if (portfolioIds !== undefined)
    portfolioIds && portfolioIds.forEach(item => { url_ += "portfolioIds=" + encodeURIComponent("" + item) + "&"; });
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let portfoliosGetSectionLookupDefaultOptions: Omit<UseQueryOptions<Types.ListResultDtoOfSectionLookupDto, unknown, Types.ListResultDtoOfSectionLookupDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.ListResultDtoOfSectionLookupDto, unknown, Types.ListResultDtoOfSectionLookupDto>, 'queryFn'>> = {
};
export function getPortfoliosGetSectionLookupDefaultOptions() {
  return portfoliosGetSectionLookupDefaultOptions;
};
export function setPortfoliosGetSectionLookupDefaultOptions(options: typeof portfoliosGetSectionLookupDefaultOptions) {
  portfoliosGetSectionLookupDefaultOptions = options;
}

export function portfoliosGetSectionLookupQueryKey(portfolioIds?: string[] | undefined): QueryKey;
export function portfoliosGetSectionLookupQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { portfolioIds,  } = params[0] as PortfoliosGetSectionLookupPortfoliosQueryParameters;

    return trimArrayEnd([
        'PortfoliosClient',
        'portfoliosGetSectionLookup',
        portfolioIds as any,
      ]);
  } else {
    return trimArrayEnd([
        'PortfoliosClient',
        'portfoliosGetSectionLookup',
        ...params
      ]);
  }
}
export function __portfoliosGetSectionLookup(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.portfoliosGetSectionLookup(
      context.queryKey[2] as string[] | undefined,axiosConfig    );
}

export function usePortfoliosGetSectionLookupQuery<TSelectData = Types.ListResultDtoOfSectionLookupDto, TError = unknown>(dto: PortfoliosGetSectionLookupPortfoliosQueryParameters, options?: Omit<UseQueryOptions<Types.ListResultDtoOfSectionLookupDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * @param portfolioIds (optional) 
 * @return OK
 */
export function usePortfoliosGetSectionLookupQuery<TSelectData = Types.ListResultDtoOfSectionLookupDto, TError = unknown>(portfolioIds?: string[] | undefined, options?: Omit<UseQueryOptions<Types.ListResultDtoOfSectionLookupDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function usePortfoliosGetSectionLookupQuery<TSelectData = Types.ListResultDtoOfSectionLookupDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.ListResultDtoOfSectionLookupDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let portfolioIds: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ portfolioIds,  } = params[0] as PortfoliosGetSectionLookupPortfoliosQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [portfolioIds, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.ListResultDtoOfSectionLookupDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __portfoliosGetSectionLookup(context, axiosConfig) : __portfoliosGetSectionLookup,
    queryKey: portfoliosGetSectionLookupQueryKey(portfolioIds),
    ...portfoliosGetSectionLookupDefaultOptions as unknown as Omit<UseQueryOptions<Types.ListResultDtoOfSectionLookupDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * @param portfolioIds (optional) 
 * @return OK
 */
export function setPortfoliosGetSectionLookupData(queryClient: QueryClient, updater: (data: Types.ListResultDtoOfSectionLookupDto | undefined) => Types.ListResultDtoOfSectionLookupDto, portfolioIds?: string[] | undefined) {
  queryClient.setQueryData(portfoliosGetSectionLookupQueryKey(portfolioIds),
    updater
  );
}

/**
 * @param portfolioIds (optional) 
 * @return OK
 */
export function setPortfoliosGetSectionLookupDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.ListResultDtoOfSectionLookupDto | undefined) => Types.ListResultDtoOfSectionLookupDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function portfoliosAddAssetUrl(id: string, sectionId: string): string {
  let url_ = getBaseUrl() + "/api/portfolios/{id}/sections/{sectionId}/assets";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
if (sectionId === undefined || sectionId === null)
  throw new Error("The parameter 'sectionId' must be defined.");
url_ = url_.replace("{sectionId}", encodeURIComponent("" + sectionId));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function portfoliosAddAssetMutationKey(id: string, sectionId: string): MutationKey {
  return trimArrayEnd([
      'PortfoliosClient',
      'portfoliosAddAsset',
      id as any,
      sectionId as any,
    ]);
}

/**
 * @param body (optional) 
 * @return OK
 */
export function usePortfoliosAddAssetMutation<TContext>(id: string, sectionId: string, options?: Omit<UseMutationOptions<Types.PortfolioDto, unknown, Types.SectionAssetCreateDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.PortfolioDto, unknown, Types.SectionAssetCreateDto, TContext> {
  const key = portfoliosAddAssetMutationKey(id, sectionId);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (body: Types.SectionAssetCreateDto) => Client.portfoliosAddAsset(id, sectionId, body),
    mutationKey: key,
  });
}
  
type PortfoliosAddAsset__MutationParameters = PortfoliosAddAssetPortfoliosQueryParameters & {
  body: Types.SectionAssetCreateDto;
}

/**
 * @param body (optional) 
 * @return OK
 */
export function usePortfoliosAddAssetMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<Types.PortfolioDto, unknown, PortfoliosAddAsset__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: PortfoliosAddAssetPortfoliosQueryParameters}): UseMutationResult<Types.PortfolioDto, unknown, PortfoliosAddAsset__MutationParameters, TContext> {
  const key = portfoliosAddAssetMutationKey(options?.parameters?.id!, options?.parameters?.sectionId!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: PortfoliosAddAsset__MutationParameters) => Client.portfoliosAddAsset(data.id ?? options?.parameters?.id!, data.sectionId ?? options?.parameters?.sectionId!, data.body),
  mutationKey: key,
});
}
  
export function portfoliosUpdateAssetUrl(id: string, sectionId: string, assetId: string): string {
  let url_ = getBaseUrl() + "/api/portfolios/{id}/sections/{sectionId}/assets/{assetId}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
if (sectionId === undefined || sectionId === null)
  throw new Error("The parameter 'sectionId' must be defined.");
url_ = url_.replace("{sectionId}", encodeURIComponent("" + sectionId));
if (assetId === undefined || assetId === null)
  throw new Error("The parameter 'assetId' must be defined.");
url_ = url_.replace("{assetId}", encodeURIComponent("" + assetId));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function portfoliosUpdateAssetMutationKey(id: string, sectionId: string, assetId: string): MutationKey {
  return trimArrayEnd([
      'PortfoliosClient',
      'portfoliosUpdateAsset',
      id as any,
      sectionId as any,
      assetId as any,
    ]);
}

/**
 * @param body (optional) 
 * @return OK
 */
export function usePortfoliosUpdateAssetMutation<TContext>(id: string, sectionId: string, assetId: string, options?: Omit<UseMutationOptions<Types.PortfolioDto, unknown, Types.SectionAssetUpdateDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.PortfolioDto, unknown, Types.SectionAssetUpdateDto, TContext> {
  const key = portfoliosUpdateAssetMutationKey(id, sectionId, assetId);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (body: Types.SectionAssetUpdateDto) => Client.portfoliosUpdateAsset(id, sectionId, assetId, body),
    mutationKey: key,
  });
}
  
type PortfoliosUpdateAsset__MutationParameters = PortfoliosUpdateAssetPortfoliosQueryParameters & {
  body: Types.SectionAssetUpdateDto;
}

/**
 * @param body (optional) 
 * @return OK
 */
export function usePortfoliosUpdateAssetMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<Types.PortfolioDto, unknown, PortfoliosUpdateAsset__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: PortfoliosUpdateAssetPortfoliosQueryParameters}): UseMutationResult<Types.PortfolioDto, unknown, PortfoliosUpdateAsset__MutationParameters, TContext> {
  const key = portfoliosUpdateAssetMutationKey(options?.parameters?.id!, options?.parameters?.sectionId!, options?.parameters?.assetId!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: PortfoliosUpdateAsset__MutationParameters) => Client.portfoliosUpdateAsset(data.id ?? options?.parameters?.id!, data.sectionId ?? options?.parameters?.sectionId!, data.assetId ?? options?.parameters?.assetId!, data.body),
  mutationKey: key,
});
}
  
export function portfoliosDeleteAssetUrl(id: string, sectionId: string, assetId: string): string {
  let url_ = getBaseUrl() + "/api/portfolios/{id}/sections/{sectionId}/assets/{assetId}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
if (sectionId === undefined || sectionId === null)
  throw new Error("The parameter 'sectionId' must be defined.");
url_ = url_.replace("{sectionId}", encodeURIComponent("" + sectionId));
if (assetId === undefined || assetId === null)
  throw new Error("The parameter 'assetId' must be defined.");
url_ = url_.replace("{assetId}", encodeURIComponent("" + assetId));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function portfoliosDeleteAssetMutationKey(id: string, sectionId: string, assetId: string): MutationKey {
  return trimArrayEnd([
      'PortfoliosClient',
      'portfoliosDeleteAsset',
      id as any,
      sectionId as any,
      assetId as any,
    ]);
}

/**
 * @return OK
 */
export function usePortfoliosDeleteAssetMutation<TContext>(id: string, sectionId: string, assetId: string, options?: Omit<UseMutationOptions<Types.PortfolioDto, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.PortfolioDto, unknown, void, TContext> {
  const key = portfoliosDeleteAssetMutationKey(id, sectionId, assetId);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: () => Client.portfoliosDeleteAsset(id, sectionId, assetId),
    mutationKey: key,
  });
}
  
type PortfoliosDeleteAsset__MutationParameters = PortfoliosDeleteAssetPortfoliosQueryParameters

/**
 * @return OK
 */
export function usePortfoliosDeleteAssetMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<Types.PortfolioDto, unknown, PortfoliosDeleteAsset__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: PortfoliosDeleteAssetPortfoliosQueryParameters}): UseMutationResult<Types.PortfolioDto, unknown, PortfoliosDeleteAsset__MutationParameters, TContext> {
  const key = portfoliosDeleteAssetMutationKey(options?.parameters?.id!, options?.parameters?.sectionId!, options?.parameters?.assetId!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: PortfoliosDeleteAsset__MutationParameters) => Client.portfoliosDeleteAsset(data.id ?? options?.parameters?.id!, data.sectionId ?? options?.parameters?.sectionId!, data.assetId ?? options?.parameters?.assetId!),
  mutationKey: key,
});
}